import React from 'react';
import { useLanguage } from '../../i18n/LanguageContext';

// Botón para alternar idioma ES/EN. Muestra el idioma al que se cambiará.
const LanguageToggle = ({ className = '' }) => {
    const { lang, toggleLang } = useLanguage();
    const next = lang === 'es' ? 'EN' : 'ES';

    return (
        <button
            type="button"
            onClick={toggleLang}
            aria-label={lang === 'es' ? 'Switch to English' : 'Cambiar a español'}
            className={`inline-flex items-center gap-2 rounded-full border border-white/25 px-3 py-1.5 text-sm font-semibold text-white hover:border-salient-green hover:text-salient-green transition-colors duration-300 ${className}`}
        >
            <i className="fas fa-globe text-xs"></i>
            <span>{next}</span>
        </button>
    );
};

export default LanguageToggle;
